// extracted by mini-css-extract-plugin
module.exports = {"heading":"video_heading__nX0Pr","videoContainer":"video_videoContainer__FD6pr","video":"video_video__d_yEY","descriptionVideoMargin":"video_descriptionVideoMargin__QA1__"};